import MyTable from "components/UIElements/MyTable";


export default function Vehicles({ endPoint, exportFilename, exportDataTitle }) {

    const columns = [
        {
            title: 'Day',
            key: 'date',
            dataIndex: 'date',
        },
        {
            title: 'Cars_number',
            key: 'cars_Number',
            dataIndex: 'cars_Number',
        },
        {
            title: 'Trips_number',
            key: 'trips_Number',
            dataIndex: 'trips_Number',
        },
        {
            title: 'Total_Distance_Km',
            key: 'total_Distance_KM',
            dataIndex: 'total_Distance_KM',
        },
        {
            title: 'Total_Time_Hours',
            key: 'total_Time_Hours',
            dataIndex: 'total_Time_Hours',
        }
    ]

    return <MyTable columns={columns} endPoint={endPoint} exportFilename={exportFilename} exportDataTitle={exportDataTitle}/>
}